var swiperThumbs = new Swiper(".thumb-swiper", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    320: { slidesPerView: 5 },
    768: { slidesPerView: 7 },
    1024: { slidesPerView: 8 },
    1440: { slidesPerView: 10 },
  },
}); 
  // Initialize Swiper
  var swiperMain = new Swiper(".swiper.main-swiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination-main",
      clickable: true,
    },
    thumbs: {
    swiper: swiperThumbs,
  },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      499: { slidesPerView: 1, spaceBetween: 16 },
    },
  });

  // Initialize Magnific Popup
  $(".image-popup-vertical-fit").magnificPopup({
    type: "image",
    mainClass: "mfp-with-zoom",
    gallery: { enabled: true },
    zoom: {
      enabled: true,
      duration: 300,
      easing: "ease-in-out",
      opener: function (openerElement) {
        return openerElement.is("img") ? openerElement : openerElement.find("img");
      },
    },
  });


